'use client';

import { motion } from 'framer-motion';
import React, { useState } from 'react';
import ContactForm from '@/components/ui/ContactForm';
import ContactSuccessModal from '@/components/ui/ContactSuccessModal';

const ContactClient = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleSuccess = () => {
    setShowSuccessModal(true);
  };

  const handleError = (error: string) => {
    setErrorMessage(error);
    // Auto-hide error after 5 seconds
    setTimeout(() => setErrorMessage(null), 5000);
  };

  return (
    <div className="relative container mx-auto px-4 py-40 md:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-8 text-center"
        >
          <div className="from-foreground via-primary to-foreground mb-4 bg-gradient-to-r bg-clip-text text-4xl leading-tight font-extrabold text-transparent md:text-5xl lg:text-6xl xl:text-7xl">
            <span className="text-foreground">Get in </span> Touch
          </div>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, delay: 0.5 }}
            className="text-muted-foreground antonio mx-auto max-w-2xl font-serif text-lg leading-relaxed sm:text-2xl"
          >
            Ready to start your next project? Let&apos;s discuss how we can work
            together to bring your ideas to life.
          </motion.p>
        </motion.div>

        {/* Contact Form */}
        <div className="mx-auto max-w-2xl">
          <ContactForm onSuccess={handleSuccess} onError={handleError} />
        </div>

        {/* Error Message */}
        {errorMessage && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="fixed top-4 right-4 z-50 max-w-md rounded-lg bg-red-500 px-6 py-3 text-white shadow-lg"
          >
            <div className="flex items-center space-x-2">
              <svg
                className="h-5 w-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span className="text-sm font-medium">{errorMessage}</span>
            </div>
          </motion.div>
        )}
      </div>

      {/* Success Modal */}
      <ContactSuccessModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        title="Message Sent Successfully!"
        message="Thank you for reaching out! I'll get back to you as soon as possible."
      />
    </div>
  );
};

export default ContactClient;
